'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* @vue/component */
exports.default = {
    name: 'filterable',
    props: {
        noDataText: {
            type: String,
            default: '$vuetify.noDataText'
        }
    }
};
//# sourceMappingURL=filterable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/mixins/filterable.js
// module id = IF+h
// module chunks = 3 4 5 6 7 8 9